module.exports = __webpack_public_path__ + "img/vuejs.82b9c7a5.png";